<template>
  <div class="annieBox">
    <div class="header" id="header">
      <i @click="goHome"></i>
      <div class="mainBox1 clearfix">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t("language") }}
          <em class="iconfont icon-een"></em>
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li
              v-for="(item, index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="settingBtn" @click.stop="setting()">
          {{ name ? name : names }}
          <em class="iconfont icon-een"></em>
          <ul v-show="settingBoxVis" class="chooseLangUl">
            <li @click="goIndex">{{ $t("myHome") }}</li>
            <li @click="race">{{ $t("myPageTitle") }}</li>
            <li @click="logOut">{{ $t("setting_2") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="mainBox clearfix" @click="clickBox" id="mainBox">
      <div class="conBox">
        <div class="left-box">
          <div class="tips">{{ courseFilter(gameId) }}</div>
          <ul>
            <li class="clearfix">
              <span class="fl">{{ $t("competition_txt1") }}</span>
              <span class="fl">{{ $t("competition_txt22") }}</span>
              <span class="fl countrys">{{ $t("competition_txt8") }}</span>
              <span class="fl">{{ $t("competition_txt3") }}</span>
            </li>
            <li v-for="(item, index) in alldata" class="clearfix" :key="index">
              <span class="fl number1">{{ item.rank }}</span>
              <span class="fl">
                {{ item.firstName }} &nbsp;{{ item.schoolCnName }}
              </span>
              <span class="fl countrys">
                {{ lan == "zh" ? "中国" : "China" }}
              </span>
              <span class="fl">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="$t('allStars')"
                  placement="top-end"
                >
                  <i class="Allstar"></i>
                </el-tooltip>
                <i class="allScore">
                  {{ item.totalScore ? item.totalScore : "/" }}
                </i>
              </span>
            </li>
          </ul>
          <!-- 分页器 -->
          <div class="pagination-container">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.page"
              :page-size="listQuery.size"
              :page-count="listQuery.count"
              layout=" prev, pager, next"
            ></el-pagination>
          </div>
        </div>

        <div class="right-box">
          <div class="gameImg" :class="{ gameImgEn: flagSte }">
            <div class="block">
              <el-carousel trigger="click" height="160px">
                <!-- 训练场 - 地球特训 - 地球公告 -->
                <el-carousel-item v-if="currentGameLevel == 0">
                  <span v-html="$t('notice_lang4')"></span>
                </el-carousel-item>
                <!-- 训练场 - 火星特训 - 火星公告 -->
                <el-carousel-item v-if="currentGameLevel == 10">
                  <span v-html="$t('mars_bulletin') + ysTime"></span>
                </el-carousel-item>
                <!-- 训练场 - 木星特训 - 木星公告 -->
                <el-carousel-item v-if="currentGameLevel == 20">
                  <span v-html="$t('jupiter_bulletin') + ysTime"></span>
                  <!-- <span>{{ ysTime }}</span> -->
                </el-carousel-item>
                <!-- 训练场 - 土星特训 - 土星公告 -->
                <el-carousel-item v-if="currentGameLevel == 30">
                  <span v-html="$t('saturn_bulletin') + ysTime"></span>
                </el-carousel-item>
                <!-- 训练场 - 五级特训 - 五级公告 -->
                <el-carousel-item v-if="currentGameLevel == 40">
                  <span v-html="$t('level5_bulletin') + ysTime"></span>
                </el-carousel-item>
                <!-- 训练场 - 六级特训 - 六级公告 -->
                <el-carousel-item v-if="currentGameLevel == 50">
                  <span v-html="$t('level6_bulletin') + ysTime"></span>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>

          <div class="allMsg allMsg1">
            <div class="myAchievement">{{ $t("MyScore") }}</div>
            <ul class="ul">
              <li class="clearfix">
                <span class="fl">{{ $t("schoolName") }}</span>
                <span class="fr">{{ schoolName ? schoolName : "/" }}</span>
              </li>
              <li>
                <span class="fl">{{ $t("myStars") }}</span>
                <span class="fr">{{ myScore ? myScore : "/" }}</span>
              </li>
            </ul>
            <button
              class="startGame"
              v-show="startGameShow"
              :class="{ fz: flagSte }"
              @click="goCode"
            >
              {{ $t("competition_button") }}
            </button>
            <el-tooltip
              class="item"
              effect="light"
              :content="getButtonTipsTxt()"
              placement="top-end"
            >
              <button
                class="startGame startGame11"
                :class="{ fz: flagSte }"
                v-show="!startGameShow"
              >
                {{ $t("competition_button") }}
              </button>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="600px">
      <span>{{ $t("broswer1") }}</span>
      <div slot="footer" class="dialog-footer" align="center">
        <a
          target="_blank"
          href="https://istatic.codingolympics.cn/soft/ChromeStandaloneSetup.exe"
        >
          {{ $t("broswer2") }}
        </a>
        &nbsp;&nbsp;
        <a
          target="_blank"
          href="https://istatic.codingolympics.cn/soft/ChromeStandaloneSetup64.exe"
        >
          {{ $t("broswer3") }}
        </a>
      </div>
    </el-dialog>

    <LeapPopup
      v-show="maskBox"
      @onOK="logOut"
      :title="$t('timeout01')"
      :content="$t('timeout02')"
      :cancelButtonTxt="$t('timeout04')"
      :okButtonTxt="$t('timeout03')"
      :isConfirm="false"
    ></LeapPopup>

    <LeapPopup
      v-show="showFirstEnter"
      @onConfirm="monthConfirmOK"
      @onCancel="monthConfirmCancel"
      :title="$t('week_game_tips_info_txt')"
      :content="$t('week_game_tips_info')"
      :cancelButtonTxt="$t('week_warning_btn_not_start')"
      :okButtonTxt="$t('week_warning_btn_start')"
      :isConfirm="true"
    ></LeapPopup>
  </div>
</template>

<script>
import store from "../store";
import { mapGetters } from "vuex";
import {gameKeyFilter} from "@/utils/gameInfo";
import MediaUtils from "@/utils/MediaUtils";
import RetCode from "@/data/RetCode";
import LeapPopup from "./LeapPopup";
import I18nUtils from "@/utils/i18nUtils";

export default {
  data() {
    return {
      startGameShow: false,
      changeLangBox: false,
      settingBoxVis: false,
      myScore: "",
      schoolName: "",
      listQuery: {
        page: 1,
        size: 10,
        count: 0,
      },
      langList: I18nUtils.langList,
      alldata: [
        {
          rank: "/",
          schoolName: "/",
          totalScore: "/",
          schoolCnName: "/",
          schoolNation: "/",
        },
      ],
      dialogVisible: false,
      flagSte: false,
      queryFlag: false,
      countryList: [],
      codeNum: "",
      names: "",
      isFirstEnter: false,
      showFirstEnter: false,
      isStartOrEnd: 0,
      isNotVipShow: false,

      currentGameLevel: "",
      batchNo: null,
      gameId: "",
      mode: "",
      level: "",
      ysTime: "",
    };
  },

  components: {
    LeapPopup,
  },

  async mounted() {
    if (MediaUtils.isMobileBrowser()) {
      let mainBox = document.getElementById("mainBox");
      mainBox.style.transform = "scale(.6)";
      mainBox.style.position = "absolute";
      mainBox.style.top = "-72px";
      mainBox.style.left = "-220px";

      // let overs = document.querySelectorAll(".over");
      // overs.forEach(over => {
      //     over.style.scale = 0.6;
      //     over.style.left = "36%";
      //     over.style.top = "4%";
      // })
    }
    this.names = localStorage.getItem("names") || "";

    I18nUtils.initLanguage(this);

    // www官网的学习中心跳转至此页面时插入url字段
    await this.getEventCode();

    // 从index中【goYs】的sessionstorage中获取到gameId，从而进行后续判断
    this.gameId = sessionStorage.getItem("gameId");
    this.codeNum = localStorage.getItem("modes");

    await this.getMsg(1, 10, this.gameId);
    this.queryUserGameScore(this.gameId);

    // 读取用户信息
    this.getUserGameMsg();

    // 公告栏获取index存入session的比赛时间 &&  使用在非
    // this.ysTime = sessionStorage.getItem("ysTime");
  },

  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },

    async getEventCode() {
      let args = {};

      const qs =
        window.location.search.length > 0
          ? window.location.search.substr(1)
          : "";
      const itemsArray = qs.length > 0 ? qs.split("&") : [];

      itemsArray.forEach((el) => {
        let item = el.split("=");
        let name = decodeURIComponent(item[0]);
        let value = decodeURIComponent(item[1]);

        if (name.length !== 0) {
          args[name] = value;

          if (name == "g") {
            sessionStorage.setItem("gameId", value);
            this.gameId = value;
          }
          if (name == "m") {
            localStorage.setItem("modes", value);
            this.mode = value;
          }
          if (name == "level") {
            sessionStorage.setItem("level", value);
            this.level = value;
          }
        }
        return args;
      });

      if (this.gameId != "" && this.mode != "" && this.level != "") {
        // 获取月赛开始时间
        await this.getGameStartTime(this.gameId);
      } else {
        console.log("url isn't from www.");
      }
    },

    // 使用于www项目跳转至月赛页面 && 调用于月赛的时间，晋级赛不需要
    async getGameStartTime(gameId) {
      try {
        let res = await this.$http.getAxios("/user/queryGameInfo", {
          method: "get",
          params: {
            gameId,
          },
        });
        const _res = res.data;

        if (_res.code == 0) {
          // 将时间戳的毫秒变为秒
          const dt = new Date(_res.data.startTimestamp * 1000);
          this.ysTime = [
            dt.getFullYear() +
              "-" +
              (dt.getMonth() + 1 < 10
                ? "0" + (dt.getMonth() + 1)
                : dt.getMonth() + 1) +
              "-" +
              (dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate()) +
              " " +
              (dt.getHours() < 10 ? "0" + dt.getHours() : dt.getHours()) +
              ":" +
              (dt.getMinutes() < 10 ? "0" + dt.getMinutes() : dt.getMinutes()),
          ];
          this.batchNo = _res.data.batchNo;
        } else {
          console.log("url isn't from www.");
        }
      } catch (error) {
        // 如果不是www官网跳转过来的尝试登录后再次判断
        let m = localStorage.getItem("modes"),
          g = sessionStorage.getItem("gameId"),
          l = sessionStorage.getItem("level");

        this.$router.push({
          path: "/signIn?g=" + g + "&m=" + m + "&level=" + l,
        });
        // 添加登录提示;
        console.log("error", error);
        this.$notify.warning({
          title: "请登录账号",
          message: "参加比赛需要登录账号",
        });
      }
    },

    getUserGameMsg() {
      this.$http
        .getAxios("/user/queryUserGameMsg", {
          method: "post",
          data: {
            gameId: this.gameId,
          },
        })
        .then((res) => {
          var res = res.data;
          if (res.code == RetCode.SUCCESS) {
            this.currentGameLevel = res.data.currentGameLevel;
            if (res.data.currentGameLevel != 0 && res.data.isVip != 1) {
              this.isNotVipShow = true;
            } else {
              this.isNotVipShow = false;
            }
            if (res.data.weekGameExpireTime <= 0) {
              this.isFirstEnter = true;
            } else {
              this.isFirstEnter = false;
            }
            if (res.data.isStartOrEnd == RetCode.CODE40001) {
              this.startGameShow = true;
            } else {
              this.startGameShow = false;
            }
            this.isStartOrEnd = res.data.isStartOrEnd;
          } else if (res.code == "5") {
            this.$router.push({ path: "/signIn" });
          } else {
            // this.$router.push({ path: "/" });
            this.$notify.error({
              title: "错误！",
              message: "错误码：Gm-" + res.code + "," + res.msg,
            });
          }
        });
    },

    getButtonTipsTxt() {
      // 状态码优先
      if (this.isStartOrEnd == RetCode.CODE40003) {
        return this.$t("game_already_closed");
      }
      // 等级不达标均不可参加比赛
      if (this.isStartOrEnd == RetCode.CODE40005) {
        return this.$t("index_txt49_lowLevel");
      }
      // 非VIP用户不可参加
      if (this.isNotVipShow) {
        return this.$t("index_txt49_noOpen");
      }
      // 游戏状态
      return this.$t("index_txt49");
    },

    monthConfirmCancel() {
      this.showFirstEnter = false;
    },
    monthConfirmOK() {
      this.showFirstEnter = false;
      this.sendEnterGame();
    },
    setStyle() {
      let [stus, ctys] = [
        document.querySelectorAll(".stuSchool"),
        document.querySelectorAll(".countrys"),
      ];

      stus.forEach((e) => {
        e.style.width = 0;
      });
      for (var i = 0; i < stus.length; i++) {
        ctys[i].style.width = "0";
        stus[i].style.width = "67%";
      }
    },
    race() {
      this.$router.push({ path: "/myPage" });
    },
    goIndex() {
      this.$router.push({ path: "/index" });
    },
    //翻页
    handleCurrentChange(val) {
      this.getMsg(val, 10, this.gameId);
    },
    getCountry(array) {
      var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      array.forEach((item) => {
        if (item.firstName || item.firstName) {
          if (reg.test(item.firstName) || reg.test(item.lastName)) {
            item.fullName = "* " + item.firstName;
          } else {
            item.fullName = item.firstName + " *";
          }
        } else {
          item.fullName = "";
        }

        for (var i = 0; i < this.countryList.length; i++) {
          if (!item.userArea) item.schoolNation = "/";
          if (item.userArea == this.countryList[i].key)
            item.schoolNation = this.countryList[i].value;
        }
      });
    },
    // 排行版rank颜色判断
    setRankColor() {
      var arr = document.getElementsByClassName("number1");
      for (var i = 0; i < arr.length; i++) {
        if (
          arr[i].innerText == "1" ||
          arr[i].innerText == "2" ||
          arr[i].innerText == "3"
        ) {
          arr[i].style.color = "yellow";
          arr[i].style.fontWeight = "900";
        } else {
          arr[i].style.color = "white";
          arr[i].style.fontWeight = "100";
        }
      }
    },
    //获取竞赛信息
    async getMsg(pageStart, pageSize, gameId) {
      try {
        this.alldata = [];
        let res = await this.$http.getAxios("/user/queryUserLeaderboards", {
          method: "get",
          params: {
            pageStart,
            pageSize,
            gameId,
            type: 0,
            rankType: 0,
            batchNo: this.batchNo,
          },
        });

        if (res.data.code == "0") {
          this.alldata = res.data.data;
          this.listQuery.count = res.data.totalPage;
          this.queryFlag = true;
          if (this.alldata.length > 0) {
            this.$nextTick(() => {
              this.setRankColor();
            });
          } else {
            this.queryFlag = false;
            this.alldata = [
              {
                rank: "/",
                schoolName: "/",
                totalScore: "/",
                schoolCnName: "/",
                schoolNation: "/",
              },
            ];
          }
        }
      } catch (err) {
        console.log("err::", err);
      }
    },

    queryUserGameScore(gameId) {
      // 一级赛每周一次
      if(gameId == "8001" || gameId == "8002") {
        return this.queryUserWeekGameScore(gameId);

      // 二级赛以上正常逻辑
      } else {
        return this._queryUserGameScore(gameId);
      }
    },

    _queryUserGameScore(gameId) {
      this.$http
        .getAxios("/game/queryUserGameScore", {
          method: "get",
          params: { 
            gameId: gameId, 
          },
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            this.myScore = res.data.score ? res.data.score : "0";
            this.schoolName = res.data.schoolName ? res.data.schoolName : "";
          }
        }); 
    },

    //
    queryUserWeekGameScore(gameId) {
      this.$http
        .getAxios("/game/queryUserWeekGameScore", {
          method: "get",
          params: { 
            gameId: gameId, 
            batchNo: this.batchNo 
          },
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            this.myScore = res.data.score ? res.data.score : "0";
            this.schoolName = res.data.schoolName ? res.data.schoolName : "";
          }
        });
    },

    moreLang() {
      this.changeLangBox = !this.changeLangBox;
      this.settingBoxVis = false;
    },

    clickBox() {
      this.changeLangBox = false;
      this.settingBoxVis = false;
    },
    goHome() {
      this.$router.push({ path: "/index" });
    },
    setting() {
      this.settingBoxVis = !this.settingBoxVis;
      this.changeLangBox = false;
    },
    toMyAccount() {
      this.$router.push({ path: "/myAccount" });
    },
    goCode() {
      // ie
      var ua = navigator.userAgent.toLocaleLowerCase();
      if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
        this.dialogVisible = true;
        return;
      }
      if (!this.isFirstEnter) {
        this.sendEnterGame();
        return;
      }
      this.showFirstEnter = true;
    },
    sendEnterGame() {
      this.$http
        .getAxios("/user/enterGame", {
          method: "post",
          data: { mode: this.codeNum, gameId: this.gameId },
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            let urls = `${process.env.GO_IDE}?highLevel=1&mode=${this.codeNum}&game=${this.gameId}&language=${this.$i18n.locale}`;
            window.location.href = urls;
            return;
          } else if (res.code == "119") {
            this.$notify.error({
              title: this.$t("ERROR"),
              message: this.$t("Sorry, you can't play the game. Please contact the admin for info."),
            });
          } else if (res.code == "122") {
              this.$notify.error({
                title: this.$t("ERROR"),
                message: this.$t("Sorry, the race doesn't exist. Please contact the admin for info."),
              });
          } else if (res.code == "123") {
              this.$notify.error({
                title: this.$t("ERROR"),
                message: this.$t("Sorry, the race is not configured. Please contact the admin for info."),
              });
          }
          
          this.$message.error(this.$t("can_not_enter_txt"));
        });
    },
    logOut() {
      this.$http
        .getAxios("/user/logout", {
          method: "post",
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            store.commit("toggleMaskState", false);

            sessionStorage.removeItem("gameId");
            sessionStorage.removeItem("level");

            this.$router.push({ path: "/" });
          }
        });
    },
    cancel() {
      store.commit("toggleMaskState", false);
    },

    // isMonthlyCompetition(gameId){
    //   return 200600 < gameId && gameId < 291232;
    // },
    // 处理比赛名称的显示
    courseFilter(gameId) {
      let rs = gameKeyFilter(gameId);
      //存在keyValue，按月赛处理
      if (rs.keyValue) {
        return this.$t(rs.key,rs.keyValue);
      }
      //如果配置了就读语言包
      return this.$t(rs.key);
    },
  },

  computed: {
    ...mapGetters(["maskBox", "name"]),
    lan() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mainBox {
  width: 1200px;
  position: relative;
  margin: 0 auto;
}
.annieBox .header {
  height: 60px;
  font-weight: bold;
  font-size: 20px;
  line-height: 60px;
  padding-left: 30px;
  color: #aaf9fe;
  background: #122346;
  i {
    position: absolute;
    top: 8px;
    left: 40px;
    width: 172px;
    height: 46px;
    cursor: pointer;
    z-index: 9999999999999;
    background: url("~@/assets/images/bigIcon.png") no-repeat center;
  }
  .mainBox1 {
    height: 60px;
    position: absolute;
    top: 0;
    right: 20px;
    z-index: 323223;
  }
  .settingBtn,
  .changeLangBtn {
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    padding-right: 20px;
  }
  .settingBtn {
    padding-right: 20px;
  }
  .chooseLangUl {
    position: absolute;
    z-index: 111;
    background: rgb(12, 53, 92);
    border-radius: 5px;
    padding: 0px 10px 15px;
    li {
      height: 40px;
      cursor: pointer;
    }
  }
}
.annieBox .conBox {
  padding-top: 40px;
}
.annieBox .left-box {
  width: 51%;
  float: left;
  position: relative;
  .before51 {
    color: #aaf9fe;
    font-size: 20px;
    line-height: 40px;
    padding-bottom: 20px;
    font-weight: bold;
  }
  .tips {
    width: 100%;
    height: 58px;
    background: url("~@/assets/images/tips.png") no-repeat center;
    background-size: contain;
    margin: 0 auto;
    text-align: center;
    color: #00ffff;
    font-size: 24px;
    line-height: 58px;
    margin-bottom: 50px;
  }
  .leaderBoardTit {
    text-shadow: 3px 3px 1px #1e86a5;
    color: #aaf9fe;
    text-align: center;
    width: 630px;
    margin-left: -10px;
    font-size: 28px;
    padding-bottom: 25px;
  }
  ul {
    border: solid 2px rgba(40, 186, 208, 0.9);
    border-radius: 5px;
    li {
      border-bottom: 1px solid rgba(11, 97, 134, 0.14);
      background: rgba(00, 46, 72, 0.9);
      &:last-of-type {
        border-bottom: none;
      }
      &:nth-of-type(1) {
        // background:rgba(,.9)
        background: #1e86a5;
        opacity: 0.9;
      }
      span {
        display: block;
        text-align: center;
        line-height: 48px;
        color: #fff;
        &:nth-of-type(1) {
          width: 7%;
          border-right: 1px solid rgba(11, 97, 134, 0.14);
        }
        &:nth-of-type(2) {
          width: 60%;
          border-right: 1px solid rgba(11, 97, 134, 0.14);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        &:nth-of-type(4) {
          width: 15%;
          border-right: 1px solid rgba(11, 97, 134, 0.14);
          position: relative;
          i {
            font-style: normal;
            display: inline-block;
            vertical-align: middle;
          }
          .Allstar {
            width: 20px;
            height: 20px;
            background: url("~@/assets/images/star.png") no-repeat center;
            background-size: cover;
          }
          .optimizeSteps {
            width: 20px;
            height: 20px;
            margin-left: 7px;
            background: url("~@/assets/images/step.png") no-repeat center;
            background-size: cover;
          }
          .optimizeLine {
            width: 20px;
            height: 20px;
            margin-left: 10px;
            margin-right: 4px;
            background: url("~@/assets/images/line.png") no-repeat center;
            background-size: cover;
          }
        }
        &:nth-of-type(3) {
          width: 17%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          border-right: 1px solid rgba(11, 97, 134, 0.14);
        }
      }
    }
  }
}
.annieBox .right-box {
  width: 41%;
  float: right;
  .gameImg {
    background: url("~@/assets/images/steZh.png") no-repeat center;
    background-size: contain;
    height: 310px;
    position: relative;
    margin-bottom: 50px;
    .block {
      width: 80%;
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
      /deep/ button[type="button"] {
        display: none !important;
      }
    }
    span {
      // width:400px;
      // position:absolute;
      // top:120px;
      // left:50%;
      line-height: 30px;
      // transform:translateX(-50%);
      color: #fff;
    }
  }
  .gameImgEn {
    background: url("~@/assets/images/steEn.png") no-repeat center;
    background-size: contain;
    height: 310px;
    position: relative;
    .block {
      width: 84%;
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
      button[type="button"] {
        display: none !important;
      }
    }
    span {
      // width:400px;
      // position:absolute;
      // top:120px;
      // left:50%;
      line-height: 30px;
      // transform:translateX(-50%);
      color: #fff;
    }
  }
  .schoolOfLeapLearner {
    height: 59px;
    background-color: #f3dd47;
    margin: 10px 0;
    font-size: 30px;
    color: #3c3f53;
    line-height: 59px;
    text-align: center;
    font-weight: bold;
  }
  .allMsg {
    width: 100%;
    height: 209px;
    background: url("~@/assets/images/tab01.png") no-repeat center;
    position: relative;
    padding-top: 1px;
    .myAchievement {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      color: #00ffff;
      font-size: 28px;
      top: -5px;
    }
    .codeTogame {
      position: absolute;
      top: 58px;
      font-size: 24px;
      color: #fff;
      height: 10%;
      width: 32%;
      left: 49px;
      line-height: 50px;
      text-align: center;
      cursor: pointer;
      font-weight: 700;
    }
    .blocklyGame {
      left: 289px;
      i {
        background-color: #f56c6c;
        border-radius: 10px;
        color: #fff;
        display: inline-block;
        font-size: 12px;
        height: 18px;
        line-height: 18px;
        padding: 0 6px;
        text-align: center;
        white-space: nowrap;
        position: absolute;
        top: -8px;
        right: 16px;
      }
    }
    .ul {
      padding: 40px;
      margin-top: 20px;
      li {
        height: 58px;
        line-height: 58px;
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
      }
    }
    .startGame {
      cursor: pointer;
      width: 391px;
      height: 73px;
      background: url("~@/assets/images/goGame.png") no-repeat center;
      font-size: 28px;
      color: #3c3f53;
      line-height: 73px;
      border: none;
      margin: 0 auto;
      margin-top: 30px;
      display: block;
      font-weight: bold;
      transform: scale(1);
      transition: All 0.5s ease-in-out;
    }
    .startGame:hover {
      transform: scale(1.05);
      transition: All 0.5s ease-in-out;
    }
    .fz {
      font-size: 22px;
    }
  }
  .allMsg1 {
    background: url("~@/assets/images/tab02.png") no-repeat center;
  }
}
.annieBox .opacity {
  opacity: 0.3;
}
.annieBox .left-box span {
  font-size: 14px;
}
.annieBox .right-box .startGame11 {
  background: url("~@/assets/images/learnNo.png") no-repeat center !important;
  cursor: not-allowed !important;
}
.annieBox /deep/ .el-pager li.active {
  color: yellow !important;
  font-size: 16px;
}
.annieBox /deep/ .el-pager li {
  background: red;
}
.annieBox /deep/ .pagination-container {
  text-align: center;
  margin-top: 20px;
  button {
    background: transparent;
    color: white;
    i.el-icon {
      font-size: 18px;
    }
  }
  ul {
    border: none;
    li {
      background: transparent !important;
      color: white;
      font-size: 14px;
      border-bottom: none;
    }
  }
}
.annieBox /deep/ .el-pagination button:disabled {
  background: transparent !important;
}

// 多的css
.del {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 67px;
  top: 25px;
  z-index: 1;
  cursor: pointer;
}
.over {
  width: 50%;
  height: 467px;
  position: absolute;
  top: 20%;
  background: url("~@/assets/images/timeout.png") no-repeat 1px 2px;
  left: 50%;
  transform: translateX(-50%);
}
.sOver1 {
  width: 100%;
  height: 100%;
  border-radius: 60px;
}
.over1 {
  width: 564px;
  height: 458px;
}
.bgiOver {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
}
.timeout01 {
  width: 184px;
  height: 58px;
  position: absolute;
  top: 21px;
  left: 191px;
  z-index: 1;
  text-align: center;
  line-height: 58px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
}
.timeout02 {
  width: 500px;
  height: 200px;
  position: absolute;
  top: 100px;
  left: 30px;
  text-align: center;
  line-height: 200px;
  color: #fff;
  font-size: 19px;
  font-weight: 700;
}
.timeout03 {
  width: 100px;
  height: 40px;
  position: absolute;
  top: 354px;
  left: 69px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  font-weight: 700;
}
.timeout04 {
  width: 100px;
  height: 40px;
  position: absolute;
  top: 354px;
  left: 400px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 23px;
  cursor: pointer;
  font-weight: 700;
}
.sorce {
  width: 32%;
  height: 100px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  span {
    position: absolute;
    width: 100%;
    top: 30%;
    text-align: center;
    font-size: 22px !important;
    color: #1e86a5;
  }
  span:nth-of-type(2) {
    top: 60%;
    text-align: right;
    width: 87%;
  }
}
.sorceEn span {
  font-size: 22px !important;
}
.sorceEn span:nth-of-type(2) {
  width: 84%;
}
.stuSorceGloble {
  margin-left: 2px;
}
.stuSorceSch {
  width: 34%;
}
.lineColor {
  color: #aaf9fe !important;
  font-weight: 700;
  // transform:scale(1.1)
}
.bgStar {
  background: url("~@/assets/images/bgStar.png") no-repeat center;
  background-size: contain;
}
.gradeLevel {
  text-align: center;
  color: #fff;
  font-size: 22px;
  margin: 10px 0 20px 0;
  height: 30px;
  color: #1e86a5;
  width: 49%;
}
.arrow {
  width: 20px;
  height: 33px;
  position: absolute;
  top: 55%;
  cursor: pointer;
}
.leftArrow {
  background: url("~@/assets/images/leftArrow.png") no-repeat center;
  background-size: contain;
  left: -30px;
}
.rightArrow {
  background: url("~@/assets/images/rightArrow.png") no-repeat center;
  background-size: contain;
  right: -30px;
}
.ewm {
  margin-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  span {
    float: left;
  }
}
.ewmBg {
  width: 80px;
  height: 80px;
  background: url("~@/assets/images/ewm.jpg") no-repeat center;
  background-size: contain;
  float: right;
  margin-top: -35px;
  margin-left: -20px;
}
</style>



// WEBPACK FOOTER //
// src/components/monthly.vue